import '../assets/styles/Footer.css';

export default function Footer() {
  const menuLinks = [
    { id: 1, href: '#inicio', label: 'Início' },
    { id: 2, href: '#servicos', label: 'Serviços' },
    { id: 3, href: '#contato', label: 'Contato' }
  ];

  return (
    <footer id="contato" className="footer">
      <div className="footer-container">
        <div className="footer-columns">
          <div className="footer-column">
            <h3>Contato</h3>
            <p>WhatsApp: +55 48 9664-4407</p>
            <p>E-mail: ifixservicos.br@gmail.com</p>
          </div>
          
          <div className="footer-column">
            <h3>Menu</h3>
            <ul>
              {menuLinks.map((link) => (
                <li key={link.id}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <p className="footer-copyright">
          © Copyright 2026 ifix service - Direitos reservados.
        </p>
      </div>
    </footer>
  );
}
